import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";

export const _SYSTEM_SETTING_URL = "system-settings";

export async function getSystemSettingList(params) {
    const response = await ApiBase.get(`${_SYSTEM_SETTING_URL}`);

    return response.items;
}

export async function updateSystemSetting(id, params) {
    const response = await ApiBase.patch(`${_SYSTEM_SETTING_URL}/${id}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_SYSTEM_SETTING"))

    return response;
}

